import { render } from "./CVBuilder.vue?vue&type=template&id=f0d15722&scoped=true&lang=true"
import script from "./CVBuilder.vue?vue&type=script&lang=js"
export * from "./CVBuilder.vue?vue&type=script&lang=js"

import "./CVBuilder.vue?vue&type=style&index=0&id=f0d15722&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0d15722"]])

export default __exports__